//AXIOS
import axios from "axios"
//API
import { API_INSTANCE } from "./ApiEndpoints"
//UTILS
import currentStorage, { clearAuthStorage } from "../../utils/currentStorage"

const logout = () => {
    const fullPath = window.location.pathname + window.location.search

    clearAuthStorage()

    window.location.href =
        "/auth/login" + `?next=${encodeURIComponent(fullPath)}`
}

export default function ApiRequest() {
    const storage = currentStorage()

    const request = axios.create({
        baseURL: `${API_INSTANCE}/v1`,
        headers: {
            Authorization: `Bearer ${
                storage.getItem("accessToken")
                    ? storage.getItem("accessToken")
                    : null
            }`,
            "ngrok-skip-browser-warning": "true",
        },
        responseType: "json",
        socketPath: null,
    })

    request.interceptors.response.use(
        (response: any): any => response,
        (error: any) => {
            if (error.code === "ERR_NETWORK") {
                return Promise.reject({
                    status: 0,
                    data: { message: "Network error. Please check your connection." },
                })
            }

            if (error?.response?.status === 401) {
                logout()
            }

            if (error?.response?.status === 403) {
                logout()
                return Promise.reject(error.response)
            }

            return Promise.reject(
                error?.response || {
                    status: 0,
                    data: { message: "Unexpected request error" },
                }
            )
        }
    )

    return request
}
